import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { useAuth } from "../../../../contexts/AuthContext";
import { useParams } from "react-router-dom";
import { IntakeQuestion } from "../../../../models/IntakeQuestion";
import { useMatterType } from "../../../../contexts/MatterTypeContext";
import { Button } from "../../../../design/button";
import { Table, TableCell, TableRow } from "../../../../design/table";
import { TrashIcon } from "@heroicons/react/20/solid";
import { Input } from "../../../../design/input";
import LoadingView from "../../../../components/LoadingView";
import { Heading } from "../../../../design/heading";
import CreateIntakeQuestionButton from "./CreateIntakeQuestionButton";

const MatterTypeIntakeQuestionList: React.FC = () => {
  const { user } = useAuth();
  const { matterTypeId } = useParams<{ matterTypeId: string }>();
  const {
    selectedMatterType,
    matterTypes,
    questions: originalQuestions,
  } = useMatterType();
  const [questions, setQuestions] = useState<IntakeQuestion[]>([]);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setQuestions(originalQuestions);
  }, [originalQuestions]);

  const handleDragEnd = (result: any) => {
    if (!result.destination) return;
    const reorderedQuestions = [...questions];
    const [movedItem] = reorderedQuestions.splice(result.source.index, 1);
    reorderedQuestions.splice(result.destination.index, 0, movedItem);

    // Update the index values
    const updatedQuestions = reorderedQuestions.map((q, index) => ({
      ...q,
      index,
    }));
    setQuestions(updatedQuestions);
    setHasChanges(
      JSON.stringify(updatedQuestions) !== JSON.stringify(originalQuestions),
    );
  };

  const saveChanges = async () => {};

  const onDragEnd = (result: any) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return; // No change in position
    handleDragEnd(result);
  };

  const matterType = matterTypes.find((ct) => ct._id === matterTypeId);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-2">
          <Heading>Intake Questions</Heading>
        </div>
        <div className="flex gap-4">
          {matterType && (
            <CreateIntakeQuestionButton matterType={matterType}>
              Create Question
            </CreateIntakeQuestionButton>
          )}
          <Button onClick={saveChanges} disabled={!hasChanges}>
            Save Changes
          </Button>
        </div>
      </div>
      {selectedMatterType?.questionTaskStatus === "pending" && (
        <LoadingView
          title="Analyzing Questions..."
          message="Please give us a minute"
        />
      )}
      {selectedMatterType?.questionTaskStatus === "processing" && (
        <LoadingView
          title="Processing Questions..."
          message="Please give us a minute"
        />
      )}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <Table {...provided.droppableProps} ref={provided.innerRef}>
              {questions.map((item, index) => (
                <Draggable key={item._id} draggableId={item._id} index={index}>
                  {(provided, snapshot) => (
                    <TableRow
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <TableCell>
                        <Input
                          type="text"
                          value={item.question}
                          onChange={(e) => {
                            setHasChanges(true);
                            const updatedQuestions = questions.map((q) =>
                              q._id === item._id
                                ? { ...q, question: e.target.value }
                                : q,
                            );
                            setQuestions(updatedQuestions);
                          }}
                          placeholder="Enter question"
                          className="w-full"
                        />
                      </TableCell>
                      <TableCell className="flex justify-end">
                        <Button
                          onClick={() => {
                            if (!user) return;
                            setHasChanges(true);
                            setQuestions(
                              questions.filter((q) => q._id !== item._id),
                            );
                            // setOriginalQuestions(
                            //   originalQuestions.filter((q) => q._id !== item._id),
                            // );
                          }}
                        >
                          <TrashIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Table>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default MatterTypeIntakeQuestionList;
